import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { userErrorSelector, userLoadingSelector } from 'modules/user/selectors';
import {
  clearResetEmailSendSuccess,
  clearUserError,
  clearUserPlatform,
  getUserPlatform,
  sendResetPasswordEmail,
  setUserError,
} from 'modules/user/actions';
import { PageForgotPassword } from 'components/pages/PageForgotPassword/PageForgotPassword';
import { User as UserTypes } from 'mxp-schemas';
import { getPath } from 'utils';
import { Routes } from 'constants/index';

const mapActionCreators = (dispatch: Dispatch) => ({
  resetPass: (email: string): void => {
    dispatch(getUserPlatform(email))
      .then((res: any) => {
        if (res.payload === UserTypes.UserPlatform.NOT_FOUND) {
          dispatch(setUserError(UserTypes.UserErrorCodes.LOGIN_NOT_FOUND));
          return;
        }
        dispatch(sendResetPasswordEmail(email));
      })
      .catch((e: any) => {
        // when error unknown
        dispatch(push(getPath(Routes.NOT_FOUND)));
      });
  },
  clearPreviousResults(): void {
    dispatch(clearUserError());
    dispatch(clearUserPlatform());
    dispatch(clearResetEmailSendSuccess());
  },
});

const mapStateToProps = (state: State.Root) => ({
  loading: userLoadingSelector(state),
  error: userErrorSelector(state),
});

export const PageForgotPasswordContainer = connect(mapStateToProps, mapActionCreators)(PageForgotPassword);
